import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=0839641d"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=0839641d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports